const MaximizeIcon = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAHCAYAAAA4R3wZAAAAAXNSR0IArs4c6QAAAHJJREFUGBljYMAB/v//XwXCOKQxhYGKOYB4KRD/g+IlIDFMlUgiQAUSQHwCiL8AcSAUg9jHgVgCSSmCCZQwAOJHUGwAk8ElDpYHSoJMx2kyUA7FJTBNRkAJkH/w+gUoD/I7SA1IrRFMswfMaYRooCawWgAT1ZLuCaOVDQAAAABJRU5ErkJggg==";
export {
  MaximizeIcon as default
};
//# sourceMappingURL=Maximise.png.js.map
